export const collection = {
    labels: {
        collection: "Coleção",
        collections: "Coleções",
        code: "Código",
        description: "Descrição",
        edit_collection: "Editar Coleção",
        name: "Nome",
        slug: "Slug",
        is_main: "Modelo Principal",
        is_official: "Modelo Oficial",
        platform: "Plataforma",
        platforms: "Plataformas",
        infos: "Informações",
        manufacturers: "Fabricantes",
        regions: "Regiões",
        franchises: "Franquias",
        details: "Detalhes",
        releases: "Lançamentos",
        genders: "Gêneros",
        medias: "Mídias",
        audio: "Áudio",
        subtitle: "Legenda",
        interface: "Interface",
        console: "Console",
        consoles: "Consoles",
        game: "Jogo",
        games: "Jogos",
        accessorie: "Acessório",
        accessories: "Acessórios",
        language: "Idioma",
        languages: "Idiomas",
        type_collection: "Tipo de Coleção",
        release_year: "Ano de Lançamento",
        release_date: "Data de Lançamento",
        image: "Imagem",
        images: "Imagens",
        add_gallery: "Adicionar Galeria",
        gallery: "Galeria",
        galleries: "Galerias",
        tags: "Tags",
    },
    placeholders: {
        code: "Exe: BR",
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_collection: "Adicionar Coleção",
            add_gallery: "Adicionar Galeria",
            copy_collection: "Copiar Coleção",
            edit_collection: "Editar Coleção",
            edit_gallery: "Editar Galeria",
            del_collection: "Excluir Coleção",
            del_gallery: "Excluir Galeria",
            del_image: "Excluir Imagem",
        },
        messages: {
            copy_collection: "Você deseja COPIAR a coleção <strong>{name}</strong>?",
            del_gallery: "Você deseja EXCLUIR a galeria <strong>{name}</strong>?<br/>Todos as imagens desta coleção serão excluídas.",
            del_collection: "Você deseja EXCLUIR a coleção <strong>{name}</strong>?<br/>Todos os relacionamentos desta coleção serão excluídos.",
            del_image: "Você deseja continuar com a exclusão da imagem?<br/>Esta operação nao pode ser desfeita.",
        },
    },
    texts: {
        empty_gallery: "Não há galerias cadastradas.",
        empty_items: "Não há itens cadastrados.",
        empty_images: "Não há imagens cadastradas.",
    },
};
